<template>
  <!--footer-area-start-->
  <div class="footer-area">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-4">
          <div class="footer-containt">
            <div class="footer-logo">
              <a href="#"><img src="assets/img/internet-logo.png" alt=""/></a>
            </div>
            <div class="footer-text">
              <p>
                57 rue de l’Abbé Groult <br />
                75015, Paris France
              </p>
              <a href="mailto:info@emerging">info@emerging</a>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-8">
          <div class="footer-widget-box">
            <div class="row">
              <div class="col-md-4 col-6">
                <div class="single-footer">
                  <div class="footer-title">
                    <a href="#">
                      <h3>About</h3>
                    </a>
                    <ul>
                      <li v-for="(item, i) in menuItems" :key="'menu' + i">
                        <router-link :to="item.link">{{ item.title }}</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-6">
                <div class="single-footer">
                  <div class="footer-title">
                    <h3>Follow</h3>
                    <ul>
                      <li>
                        <a href="https://www.linkedin.com/company/emerging-group/" target="_new"
                          >Linkedin</a
                        >
                      </li>
                      <li><a href="https://twitter.com/EmergingLab" target="_new">Twitter</a></li>
                      <li>
                        <a href="http://www.facebook.com/Emerginglab" target="_new">Facebook</a>
                      </li>
                      <li>
                        <a href="https://www.instagram.com/emerginglab" target="_new">Instagram</a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-6">
                <div class="single-footer">
                  <div class="footer-title">
                    <h3>Legal</h3>
                    <ul>
                      <li>
                        <router-link to="/Terms-and-Conditions">Terms & conditions</router-link>
                      </li>
                      <li><router-link to="/Privacy-Policy">Privacy policy</router-link></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="footer-bottom">
            <p>©2020 Emerging. All rights reserved</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--footer-area-end-->
</template>

<script>
import NavUtils from '@/mixins/NavUtils';
import { loadMenu } from '@/api/navItems';

export default {
  mixins: [NavUtils],
  async created() {
    let menu = await loadMenu('bottom', this.$store.state.language.iso_code);
    this.menuItems = menu[0]['menuItem'];
    this.$root.$on('update-language', val => {
      this.updateMenu('bottom', val);
    });
  }
};
</script>

<style lang="scss" scoped></style>
